"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var getStyle = function () {
    return {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    };
};
var DefaultFormatter = /** @class */ (function (_super) {
    __extends(DefaultFormatter, _super);
    function DefaultFormatter(props) {
        var _this = _super.call(this, props) || this;
        _this.onMouseOver = function () {
            _this.setTitle();
        };
        _this.state = { title: undefined };
        return _this;
    }
    DefaultFormatter.prototype.setTitle = function () {
        if (typeof this.props.value === 'string') {
            var title = void 0;
            var currElem = ReactDOM.findDOMNode(this);
            if (currElem.offsetWidth < currElem.scrollWidth) {
                title = this.props.value;
            }
            this.setState({ title: title });
        }
    };
    DefaultFormatter.prototype.render = function () {
        var style = getStyle();
        var props = {
            style: style,
            title: this.state.title,
            onMouseOver: this.onMouseOver,
            'data-tb-test-id': this.props.testId
        };
        return (React.createElement("div", __assign({}, props), this.props.value));
    };
    return DefaultFormatter;
}(React.Component));
exports.DefaultFormatter = DefaultFormatter;
//# sourceMappingURL=DefaultFormatter.js.map